import React, { useReducer } from "react";

const PaymentMethodContext = React.createContext();

const initialState = {
  paymentMethodID: null,
  paymentType: "card", // someday we'll have ACH, etc
  cardType: null, // mastercard, fize, etc
  nickname: null,
  last4: null,
  expirationMonth: null,
  expirationYear: null,
  hasOtherOwner: false,
  owner: {},
  isDefaultPaymentMethod: false,
  isEnabledForTTG: false,
  sharedWithOtherHoH: false,
  isAvailableAsSavedPaymentMethod: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "Set Payment Method": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "Update Saved Payment Method": {
      return {
        ...state,
        ID: null,
        // ...action.payload,
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

function PaymentMethodProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <PaymentMethodContext.Provider value={{ state, dispatch }}>
      {children}
    </PaymentMethodContext.Provider>
  );
}

function usePaymentMethod() {
  const context = React.useContext(PaymentMethodContext);
  if (context === undefined) {
    throw new Error(
      `usePaymentMethod must be used within a PaymentMethodProvider`
    );
  }
  return context;
}

export { PaymentMethodContext, PaymentMethodProvider, usePaymentMethod };
